const QUOTE_REGEXP = /^"|"$/g;

/**
 * Sanitizes stored data before returning it
 * @param data the data to be sanitized
 * @param reviver custom function to parse the data
 * @returns the sanitized data, `undefined` in case of a parsing error
 */
export const sanitizeStorageValue = <T>(
  data: string,
  reviver?: (this: unknown, key: string, value: unknown) => unknown
): T | undefined => {
  try {
    const isJson = data.startsWith('{') || data.startsWith('[');

    return isJson
      ? (JSON.parse(data, reviver) as T)
      : (data.replace(QUOTE_REGEXP, '') as T);
  } catch (error) {
    console.error('Error parsing localStorage data:', error);

    return undefined;
  }
};
